import { useEffect, useRef, useState } from "react";
import {
  nguyenthibichvan,
  phanthilananh,
  phamthivananh,
  dinhthithutrang,
  dangthingocanh,
  duongtuankiet,
  arrow,
  iconNext,
} from "../assets";

const ListManager = () => {
  const infoRef = useRef();
  const [isScroll, setIsScroll] = useState(false);
  useEffect(() => {
		const width = window.innerWidth;

    if (width < 1640) {
      setIsScroll(true);
    }
  }, []);

  return (
    <div className="relative w-screen bg-[white] flex items-center flex-col">
      <div className="text-[#333333] text-[26px] sm:text-[30px] lg:text-[36px] font-[700] border-b-[6px] pb-[15px] w-fit border-[#005DD7] mb-[55px] mt-[70px] text-center">
        DANH SÁCH CẤP QUẢN LÝ
      </div>
      {isScroll && (
        <img
          src={iconNext}
          alt=""
          className="absolute top-[272px] left-[20px]  z-[5] rotate-180 h-[40px] sm:h-[60px] cursor-pointer"
          onClick={() => {
            infoRef.current.scrollBy({
              left: -200,
              behavior: "smooth",
            });
          }}
        />
      )}
      {isScroll && (
        <img
          src={iconNext}
          alt=""
          className="absolute top-[272px] right-[20px] z-[5] h-[40px] sm:h-[60px] cursor-pointer"
          onClick={() => {
            infoRef.current.scrollBy({
              left: 200,
              behavior: "smooth",
            });
          }}
        />
      )}
      <div
        ref={infoRef}
        className="overflow-auto w-[100vw] flex scrollbar-hidden"
      >
        <div className={`flex gap-[40px] mx-auto mb-[50px] ${isScroll && 'px-[60px]'}`}>
          {data.map((item) => (
            <div className="flex flex-col items-center justify-center min-w-[192px] sm:min-w-[240px]">
              <img
                className="rounded-[50%] border-[5px] border-[#E9F4FF] mb-[20px] w-[150px] h-[150px] sm:w-[198px] sm:h-[198px]"
                src={item.avt}
                alt=""
              />
              <div className="text-[#333333] text-[17px] sm:text-[21px] font-[700] mb-[5px] text-center">
                {item.name}
              </div>
              <div className="text-[#767676] text-[14px] sm:text-[18px] font-[300] mb-[10px] text-center font-['system-ui']">
                {item.vitri}
              </div>
              <div
                onClick={() => window.open(item.link)}
                className="flex items-center cursor-pointer"
              >
                <div className="text-[#0084ff] text-[16px] font-[400]  mr-[5px]">
                  Xem thêm
                </div>
                <img className="w-[16px] h-[8px]" src={arrow} alt="" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListManager;

const data = [
  {
    name: "NGUYỄN THỊ BÍCH VÂN",
    vitri: "Trưởng phòng kinh doanh",
    avt: nguyenthibichvan,
    link: "https://cql.baovietnhantho.com.vn/nguyen-thi-bich-van",
  },
  {
    name: "DƯƠNG QUỐC VIỆT",
    vitri: "Trưởng phòng kinh doanh",
    avt: duongtuankiet,
    link: "https://cql.baovietnhantho.com.vn/duong-quoc-viet",
  },
  {
    name: "PHAN THỊ LAN ANH",
    vitri: "Trưởng phòng kinh doanh",
    avt: phanthilananh,
    link: "https://cql.baovietnhantho.com.vn/phan-thi-lan-anh",
  },
  {
    name: "PHẠM THỊ VÂN ANH",
    vitri: "Trưởng phòng kinh doanh",
    avt: phamthivananh,
    link: "https://cql.baovietnhantho.com.vn/pham-thi-van-anh",
  },
  {
    name: "ĐINH THỊ THU TRANG",
    vitri: "Trưởng phòng kinh doanh",
    avt: dinhthithutrang,
    link: "https://cql.baovietnhantho.com.vn/dinh-thi-thu-trang",
  },
  {
    name: "ĐẶNG THỊ NGỌC ÁNH",
    vitri: "Trưởng phòng kinh doanh",
    avt: dangthingocanh,
    link: "https://cql.baovietnhantho.com.vn/dang-thi-ngoc-anh",
  },
];
